<template>
  <section class="container">
    <div class="header" :style="{backgroundImage:'url(' + require('@/assets/bg.png') + ')'}">
      <div class="header__info">
        <span class="header__info__title">停车助手</span>
        <span class="header__info__content">线上缴费/停车提醒/先离场后支付</span>
      </div>
    </div>
    <div class="box">
      <div class="prompt_tips">输入车牌缴费</div>
      <div class="page page-index">
        <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
      </div>
      <!-- <div>
        <div>常用车辆</div>
        <div>管理></div>
      </div> -->

      <div class="btn_box">
        <van-button @click="submit" size="large" class="blue-btn">
          查询订单
        </van-button>
      </div>
    </div>
    <div class="box">
      <div class="prompt_tips">停车服务</div>
      <div class="assistant">
        <div>
          <van-image width="30" height="auto" :src=" require('@/assets/1.png')" />
        </div>
        <div class="assistant_title">
          <div>停车助手</div>
          <div class="assistant_title_Remark">您的车辆实时计费管家</div>
        </div>
        <div>
          <van-button :plain="true" @click="submit" size="small" class=" blue-btn">
            去开通
          </van-button>
        </div>
      </div>
      <div class="assistant">
        <div>
          <van-image width="30" height="auto" :src=" require('@/assets/2.png')" />
        </div>
        <div class="assistant_title">
          <div>停车先离后付</div>
          <div class="assistant_title_Remark">离场不停车，享快捷通行</div>
        </div>
        <div>
          <van-button :plain="true" @click="submit" size="small" class=" blue-btn">
            去开通
          </van-button>
        </div>
      </div>
      <div class="assistant">
        <div>
          <van-image width="30" height="auto" :src=" require('@/assets/3.png')" />
        </div>
        <div class="assistant_title">
          <div>先离后付账单</div>
          <div class="assistant_title_Remark">一键查账单，费用更清晰</div>
        </div>
        <div>
          <van-button :plain="true" @click="submit" size="small" class=" blue-btn">
            去查看
          </van-button>
        </div>
      </div>
      <div class="assistant">
        <div>
          <van-image width="30" height="auto" :src=" require('@/assets/4.png')" />
        </div>
        <div class="assistant_title">
          <div>附近停车场</div>
          <div class="assistant_title_Remark">车场难找？一键掌握停车信息</div>
        </div>
        <div>
          <van-button :plain="true" @click="submit" size="small" class=" blue-btn">
            去查看
          </van-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Image } from 'vant'
import keyboard from '@/components/keyboard/index'
import { getUrlParam } from '@/utils'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Parking-Assistant',
  components: {
    [Image.name]: Image,
    keyboard  },
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: []
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token', 'jntcImg', 'imgBtn'])
  },
  methods: {
    change (val) {
      this.plateNumber = val
    },
    submit () {
      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      let params = {
        cardNumber: _this.plateNumber.join(''),
        parkId: getUrlParam('parkId'),
        type: Number(_this.$route.query.type) || _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType

      }
      this.$store.commit('transaction/SET_BILL_PARAMS', params)
      this.$router.push({
        name: 'Temporary-Parking-Cost',
        query: {
          cardNumber: window.encodeURI(_this.plateNumber.join('')),
          parkId: getUrlParam('parkId'),
          type: Number(_this.$route.query.type) || _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType

        }
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.container {
  background-color: #f1f0f0;
  .assistant {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    &_title {
      font-size: 16px;
      width: 60%;
      &_Remark {
        font-size: 12px;
        color: rgb(133, 133, 133);
      }
    }
  }
  .box {
    background: white;
    border-radius: 10px;
    margin: 10px;
    padding: 10px;
  }
  .header {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: px2rem(140);
    min-height: px2rem(140);
    display: flex;
    align-items: center;
    // justify-content: flex-end;

    &__info {
      // width: 70%;
      height: 50%;
      display: flex;
      flex-direction: colunm;
      flex-wrap: wrap;
      align-items: center;

      span {
        text-align: left;
        margin-left: 35px;
      }

      &__title {
        width: 100%;
        font-size: 22px;
        color: black;
        font-weight: 500;
      }

      &__content {
        width: 100%;
        font-size: 14px;
        color: rgb(133, 133, 133);
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    // text-align: center;
    margin: 20px;
  }

  .page {
    padding: px2rem(15);
    margin: px2rem(10) 0 px2rem(20);
  }

  .btn_box {
    padding: 0 15px;
  }
}
</style>